(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SswFirmenevent = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  function bausteineSauber(konf, liste) {
    var set = {};
    (liste || []).forEach(function (id) { set[String(id)] = true; });
    return konf.bausteine.map(function (b) { return b.id; }).filter(function (id) { return set[id] && id !== 'flugzeit18'; });
  }
  function bausteinVon(konf, id) {
    for (var i = 0; i < konf.bausteine.length; i++) if (konf.bausteine[i].id === id) return konf.bausteine[i];
    if (konf.flugzeit && konf.flugzeit.id === id) return konf.flugzeit;
    return null;
  }
  function istCaptain(konf, liste) {
    var set = konf.captainSet.slice().sort();
    var gewaehlt = bausteineSauber(konf, liste).filter(function (id) { return set.indexOf(id) >= 0; }).sort();
    if (gewaehlt.length !== set.length) return false;
    for (var i = 0; i < set.length; i++) if (gewaehlt[i] !== set[i]) return false;
    return true;
  }

  function regelnVon(konf) {
    var r = konf.regeln || {};
    var fz = konf.flugzeit || {};
    return {
      minPersonen: r.minPersonen || 8, maxPersonen: r.maxPersonen || 20, maxZuschauer: r.maxZuschauer || 10,
      rasterMin: r.rasterMin || 30, empfangMin: r.empfangMin || 30, abschlussMin: r.abschlussMin || 30, pufferMin: r.pufferMin || 30,
      flugzeitMin: r.flugzeitMin || fz.inklusiveMin || 12,
      flugzeitSchrittMin: r.flugzeitSchrittMin || fz.schrittMin || 6,
      zeitPreisCent: r.zeitPreisCent || fz.preisCent || 2500,
      maxDauerMin: r.maxDauerMin || fz.maxDauerMin || 480
    };
  }
  function personenSauber(konf, personen) {
    var r = regelnVon(konf);
    return Math.max(r.minPersonen, Math.min(r.maxPersonen, Number(personen) || r.minPersonen));
  }
  function dauerFuer(konf, flugzeitMin, personen) {
    var r = regelnVon(konf);
    var roh = r.empfangMin + Math.max(1, Number(personen) || 1) * Math.max(0, Number(flugzeitMin) || 0) + r.abschlussMin;
    return Math.ceil(roh / r.rasterMin) * r.rasterMin;
  }
  function flugzeitFuer(konf, dauerMin, personen) {
    var r = regelnVon(konf);
    return Math.max(0, Math.floor((Number(dauerMin) - r.empfangMin - r.abschlussMin) / Math.max(1, Number(personen) || 1)));
  }
  function minDauerFuer(konf, personen) { return dauerFuer(konf, regelnVon(konf).flugzeitMin, personen); }
  function schritteFuer(konf, flugzeit) {
    var r = regelnVon(konf);
    return Math.max(0, Math.floor((Number(flugzeit) - r.flugzeitMin) / r.flugzeitSchrittMin));
  }
  function dauerGueltig(konf, dauerMin, personen) {
    var r = regelnVon(konf);
    var d = Number(dauerMin);
    return isFinite(d) && d % r.rasterMin === 0 && d >= minDauerFuer(konf, personen) && d <= r.maxDauerMin;
  }
  function dauerOptionen(konf, personen) {
    var r = regelnVon(konf);
    var p = personenSauber(konf, personen);
    var aus = [];
    for (var d = minDauerFuer(konf, p); d <= r.maxDauerMin; d += r.rasterMin) {
      var flugzeit = flugzeitFuer(konf, d, p);
      var schritte = schritteFuer(konf, flugzeit);
      var aufpreis = schritte * r.zeitPreisCent;
      aus.push({
        dauerMin: d, flugzeit: flugzeit, flugzeitMin: r.flugzeitMin + schritte * r.flugzeitSchrittMin,
        schritte: schritte, extraSchritte: schritte, aufpreisProPersonCent: aufpreis, preisProPersonCent: konf.grundpreisCent + aufpreis,
        text: dauerText(d) + ', ' + flugzeit + ' Min pro Person, ' + (aufpreis ? '+ ' + euro(aufpreis) + ' pro Person' : 'im Preis')
      });
    }
    return aus;
  }

  function rechne(konf, wahl) {
    var r = regelnVon(konf);
    var p = personenSauber(konf, wahl.personen);
    var z = Math.max(0, Math.min(r.maxZuschauer, Number(wahl.zuschauer) || 0));
    var liste = bausteineSauber(konf, wahl.bausteine);
    var minDauer = minDauerFuer(konf, p);
    var dauer = minDauer;
    var dm = wahl.dauerMin;
    if (dm != null && dm !== '' && dauerGueltig(konf, dm, p)) dauer = Number(dm);
    else if ((dm == null || dm === '') && Number(wahl.flugzeitMin) > r.flugzeitMin) dauer = Math.min(r.maxDauerMin, dauerFuer(konf, wahl.flugzeitMin, p));
    var flugzeit = flugzeitFuer(konf, dauer, p);
    var schritte = schritteFuer(konf, flugzeit);
    var aufpreis = schritte * r.zeitPreisCent;
    var captain = istCaptain(konf, liste);
    var paketPreis = konf.grundpreisCent;
    var ersparnis = 0;
    if (captain) {
      paketPreis = konf.captainPreisCent;
      var einzeln = konf.grundpreisCent;
      konf.captainSet.forEach(function (id) { einzeln += bausteinVon(konf, id).preisCent; });
      ersparnis = einzeln - konf.captainPreisCent;
      liste.forEach(function (id) { if (konf.captainSet.indexOf(id) < 0) paketPreis += bausteinVon(konf, id).preisCent; });
    } else {
      liste.forEach(function (id) { paketPreis += bausteinVon(konf, id).preisCent; });
    }
    var proPerson = paketPreis + aufpreis;
    var paket = captain && liste.length === konf.captainSet.length ? 'captain' : (liste.length === 0 ? 'crew' : 'selbst');
    return {
      personen: p, zuschauer: z, bausteine: liste, paket: paket, captain: captain,
      dauerMin: dauer, minDauerMin: minDauer, maxDauerMin: r.maxDauerMin,
      flugzeit: flugzeit, flugzeitMin: r.flugzeitMin + schritte * r.flugzeitSchrittMin,
      flugzeitSchritte: schritte, extraSchritte: schritte,
      aufpreisProPersonCent: aufpreis, aufpreisGesamtCent: aufpreis * p, paketPreisCent: paketPreis,
      preisProPersonCent: proPerson, zuschauerCent: z * konf.zuschauerCent,
      gesamtCent: proPerson * p + z * konf.zuschauerCent,
      blockMin: dauer + r.pufferMin, ersparnisCent: ersparnis
    };
  }

  function warenkorbZeilen(konf, erg, props) {
    var shop = konf.shop || {};
    var v = shop.varianten || {};
    var b = shop.bausteine || {};
    var haupt = erg.captain ? v.captain : (erg.bausteine.length ? v.selbst : v.crew);
    if (!haupt) throw new Error('Das Firmenevent ist im Shop noch nicht freigeschaltet. Bitte melden Sie sich kurz bei uns.');
    var gemeinsam = {};
    Object.keys(props.alle || {}).forEach(function (k) { gemeinsam[k] = props.alle[k]; });
    var hauptProps = {};
    Object.keys(gemeinsam).forEach(function (k) { hauptProps[k] = gemeinsam[k]; });
    Object.keys(props.haupt || {}).forEach(function (k) { hauptProps[k] = props.haupt[k]; });
    var items = [{ id: haupt, quantity: erg.personen, properties: hauptProps }];
    erg.bausteine.forEach(function (id) {
      if (erg.captain && konf.captainSet.indexOf(id) >= 0) return;
      if (!b[id]) throw new Error('Der Baustein "' + (bausteinVon(konf, id) || { name: id }).name + '" ist im Shop noch nicht freigeschaltet.');
      items.push({ id: b[id], quantity: erg.personen, properties: gemeinsam });
    });
    if (erg.flugzeitSchritte > 0) {
      if (!b.flugzeit18) throw new Error('Die zusätzliche Flugzeit ist im Shop noch nicht freigeschaltet.');
      items.push({ id: b.flugzeit18, quantity: erg.personen * erg.flugzeitSchritte, properties: gemeinsam });
    }
    if (erg.zuschauer > 0) {
      if (!b.zuschauer) throw new Error('Zuschauer sind im Shop noch nicht freigeschaltet.');
      items.push({ id: b.zuschauer, quantity: erg.zuschauer, properties: gemeinsam });
    }
    return items;
  }

  function euro(cent) {
    var n = Math.round(Number(cent) || 0);
    var ganz = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var rest = ('0' + (n % 100)).slice(-2);
    return ganz + (rest === '00' ? '' : ',' + rest) + ' €';
  }
  function dauerText(min) {
    var h = Math.floor(min / 60), m = min % 60;
    if (!m) return h + ' Std.';
    return h + ',' + (m === 30 ? '5' : String(Math.round(m / 6))) + ' Std.';
  }
  function endeVon(start, dauerMin) {
    var t = start.split(':');
    var m = Number(t[0]) * 60 + Number(t[1]) + dauerMin;
    return ('0' + Math.floor(m / 60)).slice(-2) + ':' + ('0' + (m % 60)).slice(-2);
  }

  return { rechne: rechne, warenkorbZeilen: warenkorbZeilen, istCaptain: istCaptain, euro: euro, dauerText: dauerText, endeVon: endeVon, bausteinVon: bausteinVon,
    dauerOptionen: dauerOptionen, dauerFuer: dauerFuer, flugzeitFuer: flugzeitFuer, minDauerFuer: minDauerFuer, schritteFuer: schritteFuer, dauerGueltig: dauerGueltig };
});
